import React from 'react';
import { Section } from './Section';
export function CostSection() {
  const rows = [{
    sin: 'Noche tras noche sin poder dormirte',
    costo: 'Meses de vida robados'
  }, {
    sin: 'Despertarte a las 3am sin saber qué hacer',
    costo: 'Angustia acumulada cada noche'
  }, {
    sin: 'Amanecer agotada y llegar al trabajo sin energía',
    costo: 'Rendimiento, humor y relaciones afectados'
  }, {
    sin: 'Seguir gastando en melatonina y soluciones temporales',
    costo: 'El precio de vivir en piloto automático, irritable y sin energía por un año más'
  }, {
    sin: 'Normalizar el insomnio como si fuera tu destino',
    costo: 'Un año más igual que este'
  }];
  return <Section className="bg-bgAlt py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-33">
      <div className="moon-glow top-[-300px] left-[-300px] opacity-30" data-id="element-34"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-35">
        <h2 className="font-serif text-3xl md:text-4xl text-center text-headlineLight mb-16" data-id="element-36">
          "¿Cuántas noches más vas a seguir así?"
        </h2>

        <div className="bg-[rgba(45,27,78,0.4)] border border-[rgba(232,197,245,0.2)] rounded-2xl overflow-hidden mb-16 backdrop-blur-sm" data-id="element-37">
          <div className="overflow-x-auto" data-id="element-38">
            <table className="w-full text-sm md:text-base" data-id="element-39">
              <thead data-id="element-40">
                <tr className="bg-[rgba(255,255,255,0.05)] border-b border-[rgba(232,197,245,0.2)]" data-id="element-41">
                  <th className="text-left py-5 px-6 font-semibold text-headlineLight w-1/2" data-id="element-42">
                    Sin el sistema
                  </th>
                  <th className="text-left py-5 px-6 font-semibold text-dangerSoft w-1/2" data-id="element-43">
                    Costo real
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-44">
                {rows.map((row, i) => <tr key={i} className="border-b border-[rgba(255,255,255,0.05)] last:border-0" data-id="element-45">
                    <td className="py-5 px-6 text-bodyOnDark" data-id="element-46">{row.sin}</td>
                    <td className="py-5 px-6 text-dangerSoft font-medium" data-id="element-47">
                      {row.costo}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center" data-id="element-48">
          <p className="font-serif text-3xl md:text-4xl italic text-accentText" data-id="element-49">
            "La próxima noche puede ser diferente."
          </p>
        </div>
      </div>
    </Section>;
}